import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import AppRoutes from '@/routes/AppRoutes'
import Layout from './components/Layout'
import { useTokenRefresh } from '@/hooks/useTokenRefresh'
import { usePushNotifications } from '@/hooks/usePushNotifications'
import { SentryUserContextSync } from '@/monitoring/sentry'
import { queryClient } from '@/lib/queryClient'

function App() {
  // Mantener sesión fresca y suscribir a notificaciones push
  useTokenRefresh()
  usePushNotifications()

  return (
    <QueryClientProvider client={queryClient}>
      <SentryUserContextSync />
      <BrowserRouter>
        <Layout>
          <AppRoutes />
        </Layout>
        <Toaster position="top-right" />
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
